import { Col, Container } from 'react-bootstrap';
import styled from 'styled-components';

export const InputStyle = styled.input`
    border: none;
    background: #d6ecd8;
    width: 850px;
    padding: 15px;
    margin: 0 0 25px 0;
    font-family: 'Tungsten-Medium', arial, sans-serif;
    font-size: 22px;
    line-height: 22px;
    color: #666; 
  @media (max-width: 1199px) {
    width: 640px !important;
  }
  @media (max-width: 991px) {
    width: 400px !important;
  }
 ::placeholder{
    color: ${(props)=> props?.$placeholderColor?'#666': '#CCCCD5'};
  }
  :focus::placeholder{
    color:#CCCCD5;
  }
`;
export const ImageStyle = styled.img`
  width: auto;
  height: 50px;
  cursor: pointer;
  float: right;
`;
export const SearchSiteTitle = styled.h2`
    margin: 0 0 25px 0;
    font-family: 'Tungsten-Medium', arial, sans-serif;
    font-weight: normal !important;
    color: #33a23c;
    font-size: 40px;
    line-height: 40px;
    text-transform: uppercase;
    padding-top: 15px;
    text-align: left;
`;
export const SearchSiteContainer = styled.div`
  display: block;
  width: 1200px !important;
  margin: 0 auto;
  padding: 25px 0 2px;
  font-size: 16px;
  line-height: 16px;
  @media (max-width: 1199px) {
    width: 960px !important;
  }
  @media (max-width: 991px) {
    width: 728px !important;
  }
`;
export const InputCol = styled(Col)`
  padding-top: 6px;
`;
export const ImageCol = styled(Col)`
  padding-top: 6px;
`;
export const SearchSiteInput = styled.input`
width: 100%;
    height: 62px;
    padding: 0 20px;
    font-family: 'Tungsten-Medium', arial, sans-serif;
    font-size: 24px;
    line-height: 24px;
    text-transform: uppercase;
    color: #fff;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    background: none;
    border: none;
  &:focus {
    &::placeholder {
      color: #02649F;
      opacity: 1;
    }
    &:-ms-input-placeholder {
      color: #02649F;
    }
    &::-ms-input-placeholder {
      color: #02649F;
    }
  }
  &::placeholder {
    color: #fff;
    opacity: 1;
  }
  &:-ms-input-placeholder {
    color: #fff;
  }
  &::-ms-input-placeholder {
    color: #fff;
  }
`;
